import { FC, Fragment, useEffect, useState } from 'react';
import cn from 'classnames';
import { useRouter } from 'next/router';

import useBiasSearch from '@hooks/useBiasSearch';
import useScrollRestoration from '@hooks/useScrollRestoration';

import { groupFilteredData, slugify } from '@lib/helpers';

import styles from './MobileView.module.scss';

interface MobileViewProps {
  biases: any; // TODO - Mary: change to StrapiBiasType[]
  page: string;
  setIsMobileFullHeight?: (isMobileFullHeight: boolean) => void;
}

const defaultArrayState = [
  Array.from({ length: 33 }, (_, i) => i + 1), // 1 - 33
  Array.from({ length: 35 }, (_, i) => i + 34), // 34 - 68
  Array.from({ length: 29 }, (_, i) => i + 69), // 69 - 97
  Array.from({ length: 8 }, (_, i) => i + 98), // 98 - 105
];

const MobileView: FC<MobileViewProps> = ({
  biases,
  page,
  setIsMobileFullHeight,
}) => {
  const router = useRouter();
  const { searchResults } = useBiasSearch()[1];
  const [content, setContent] = useState(defaultArrayState);

  const openBiasModal = (id: number, name: string) => {
    router.push(`/${page}/${id}-${name}`);
  };

  useEffect(() => {
    const groupedData = groupFilteredData(biases, searchResults, 'en');
    if (groupedData.length === 0) {
      setContent(defaultArrayState);
    } else {
      setContent(groupedData);
    }
  }, [searchResults, biases]);

  useEffect(() => {
    if (setIsMobileFullHeight) {
      setIsMobileFullHeight(content.flat().length < 10);
    }
  }, [content]);

  useScrollRestoration();

  return (
    <>
      <div className={styles.biasWrapper}>
        {content.map((cat, catIndex) => {
          return (
            <Fragment key={catIndex}>
              {cat.map((biasNumber: number) => {
                const currentStrapiBias = biases.find(
                  ({ id }) => id === biasNumber,
                );
                if (!!currentStrapiBias || !!biases) {
                  return (
                    <div
                      className={styles.bias}
                      onClick={() =>
                        openBiasModal(
                          biasNumber,
                          slugify(currentStrapiBias.attributes.title),
                        )
                      }
                      key={biasNumber}
                    >
                      <span className={styles.text}>
                        #{currentStrapiBias.attributes.number}{' '}
                        {currentStrapiBias.attributes.title}
                      </span>
                      <img
                        src={`/assets/rarityLevels/${currentStrapiBias?.attributes.biasUses?.data[0]?.attributes?.rating?.toLowerCase()}.svg`}
                        height="14"
                        width="20"
                        alt={
                          currentStrapiBias?.attributes.biasUses?.data[0]
                            ?.attributes?.rating
                        }
                        className={cn(styles.img, {
                          [styles.legendary]:
                            currentStrapiBias?.attributes.biasUses?.data[0]?.attributes?.rating?.toLowerCase() ===
                            'legendary',
                        })}
                      />
                    </div>
                  );
                }
                return null;
              })}
            </Fragment>
          );
        })}
      </div>
      <span className={styles.quote}> Be Mindful. </span>
    </>
  );
};

export default MobileView;
